import actions from './hackathon-2025.actions'
import getters from './hackathon-2025.getters'

export default {
  namespaced: true,
  actions,
  getters,
}
